<template>
	<div>
		<div class="d-flex align-items-center justify-content-between mg-b-25">
			<h3 class="df-title">Manage Policies</h3>
			<div class="d-flex">
				<router-link class="btn btn-sm btn-outline-default shadow-sm mg-l-5" :to="{ name: 'policies.new' }">
					<i data-feather="clipboard" class="wd-10 mg-r-5"></i> Create Policy
				</router-link>
			</div>
		</div>

        <div class="row">
            <div class="col-12 mg-t-20 mg-sm-t-25">
                <table id="policies-table" class="table">
                    <thead>
                        <tr>
							<th class="wd-5p"></th>
							<th class="wd-20p">Company</th>
							<th class="wd-20p">Company ID</th>
							<th class="wd-15p">Policy Type</th>
							<th class="wd-15p">Requested By</th>
                            <th class="wd-15p">Approved By</th>
                            <th class="wd-10p"></th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
	</div>
</template>

<script>
export default {
		mounted() {
			const groupColumn = 1;

			this.table = $("#policies-table").DataTable({
				processing: true,
				serverSide: true,
				ajax: {
					headers: {
						Authorization: `Bearer ${localStorage.token}`,
					},
					url: "/api/policies?datatable=true",
					dataFilter: (data) => {
						var json = JSON.parse(data);
						return JSON.stringify(json.data);
					},
				},
				responsive: true,
				deferRender: true,
				columnDefs: [
					{
						visible: false,
						targets: [0, groupColumn],
					},
					{
						targets: [0, -1],
						className: "text-center",
					},
					{
						targets: 1,
						render: function (data, type, row, meta) {
							return `<a href="/app/companies/${row[2]}" class="tx-black">${row[1]}</a>`;
						},
					},
					{
						targets: -1,
						orderable: false,
						render: function (data, type, row, meta) {
							return `<a href="/app/policies/${row[0]}" class="btn btn-sm btn-white shadow-sm mr-2"><i data-feather="edit-3" class="wd-10 mg-r-5"></i> View</a>`;
						},
					},
				],
				order: [[groupColumn, "asc"]],
				displayLength: 25,
				drawCallback: function (settings) {
					let api = this.api();
					let rows = api.rows({ page: "current" }).nodes();
					let last = null;

					api.column(groupColumn, { page: "current" })
						.data()
						.each((group, i) => {
							if (last !== group) {
								const id = rows[i].children[0].innerText;

								$(rows)
									.eq(i)
									.before(
										`<tr class="group"><td colspan="6"><a href="/app/clients/${id}" class="tx-black">${group}</a></td></tr>`
									);

								last = group;
							}
						});

					feather.replace();
				},
				language: {
					searchPlaceholder: "Search...",
					sSearch: "",
					lengthMenu: "_MENU_",
					emptyTable: "No policies available.",
				},
				initComplete: (settings, json) => {
					feather.replace();
				},
			});

			$("#policies-table tbody").on("click", "tr.group", () => {
				let currentOrder = this.table.order()[0];

				if (currentOrder[0] === groupColumn && currentOrder[1] === "asc") {
					this.table.order([groupColumn, "desc"]).draw();
				} else {
					this.table.order([groupColumn, "asc"]).draw();
				}
			});
		},
		data() {
			return {
				table: null,
			};
		},
};
</script>

<style>
</style>